angular.module('ghRadioButtonModule', [])

.directive('ghRadioButton', ['GhDialog', function(GhDialog) {
    var directive = {};

    directive.scope = {
        ghModel: '=',
        ghOptions: '=',
        ghMode: '@',
        ghFieldName: '@',
        ghChange: '&',
        editable: '='
    };

    directive.controller = ['$scope', function($scope) {
        $scope.changeValue = function(newVal) {
            if ($scope.editable) {
                $scope.ghModel = newVal.toString();
                if (typeof $scope.ghChange === 'function') {
                    $scope.ghChange({ value: $scope.ghModel });
                }
            }
        };

        $scope.isSelected = function(val) {
            return val !== null && $scope.ghModel == val;
        };

        $scope.onItemClick = function(item, event) {
            if ($scope.ghMode == 'current_value') {
                $scope.openOptionsDialog(event);
            } else {
                $scope.changeValue(item.value);
            }
        };

        $scope.openOptionsDialog = function(event) {
            if (!$scope.editable) return;
            event.stopPropagation();

            const rect = event.currentTarget.getBoundingClientRect();
            const abs_position = `top:${rect.bottom}px; left:${rect.left}px`;

            GhDialog.show({
                position: 'center_event_position',
                toolbar: true,
                mobile_position: 'bottom_mobile',
                abs_position: abs_position,
                class: 'gh-radio-button-dialog',
                template: {
                    toolbar: $scope.ghFieldName ? `<p class="gh-radio-button-dialog-title">${$scope.ghFieldName}</p>` : '',
                    content: `<ul class="gh-radio-button_dropdown">
                        <li class="gh-radio-button_dropdown-item" ng-repeat="item in ghOptions | radioButtonValue : ghModel : 'dropdown'">
                            <div ng-click="selectItem(item.value)" class="gh-button gh-button-inversed gh-color-grey gh-radio-button-item" ng-style="{\'background-color\': item.color, \'border-color\': item.color, \'color\': \'white\'}">{{item.name}}</div>
                        </li>
                    </ul>`
                },
                controller: ['$scope', function(dialogScope) {
                    dialogScope.ghOptions = $scope.ghOptions;
                    dialogScope.ghModel = $scope.ghModel;
                    dialogScope.selectItem = function(value) {
                        $scope.changeValue(value);
                        dialogScope.hide();
                    };
                }]
            }).then(function() {}, function() {});
        };
    }];

    directive.template =`
        <ul class="gh-radio-button_contain">
           <li ng-repeat="item in ghOptions | radioButtonValue : ghModel : ghMode" ng-click="onItemClick(item, $event)" class="gh-radio-button-item" ng-class="{\'selected\': isSelected(item.value), \'with-icon\': item.icon}">
             <div class="gh-button gh-button-inversed gh-color-grey gh-radio-button-item"  ng-style="isSelected(item.value) && !item.icon && {\'background-color\':item.color, \'border-color\':item.color, \'color\': \'white\', \'font-weight\': \'500\'} || { \'color\': item.color || \'#9e9e9e\' }">{{item.name}}</div>
           </li>
        </ul>`;

    return directive;
}])

.filter('radioButtonValue', function() {
    var NONE_OPTION = [{ name: 'None', value: null, placeholder: true }];

    return function(options, currentValue, interpreterType) {
        if(interpreterType == 'dropdown') return options.filter(function(opt) {
            return Number(opt.value) !== Number(currentValue);
        });
        if (options.length && interpreterType == 'current_value') {
            if(!currentValue) return NONE_OPTION;
            return options.filter(function(opt) {
                return Number(opt.value) == currentValue;
            });
        } else {
            return options;
        }
    };
});